<template>
  <div class="con">
    <head-top head-title="找回密码" goBack="true"></head-top>
    <div style="padding: 10% 0">
      <img
        :src='resourceDomain+"static/icon/logo1.png"'
        style="width: 40%; margin: 0 auto; display: block"
      />
    </div>
    <div v-if="!resetSuccess">
      <van-field
        v-model="registerAccount"
        type="tel"
        label="+86"
        left-icon="phone"
        placeholder="请输入手机号"
        maxlength="11"
        clearable
      />
      <van-field
        v-model="code"
        center
        clearable
        :left-icon="require('../../assets/img/code.png')"
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button v-if="show" size="small" type="primary" @click="getCode()"
            >获取验证码</van-button
          >
          <van-button v-if="!show" type="default">{{ count }} s</van-button>
        </template>
      </van-field>

      <van-field
        clearable
        v-model="setPassword"
        left-icon="lock"
        type="password"
        label="设置新密码"
        maxlength="20"
        placeholder="请您设置新密码"
      />

      <van-field
        clearable
        v-model="againPassword"
        left-icon="lock"
        type="password"
        label="确认新密码"
        maxlength="20"
        placeholder="请您再次输入新密码"
      />
      <div class="padding_a">
        <van-button @click="resetClick" block type="primary">
          重 置 密 码
        </van-button>
      </div>
    </div>
    <!-- 重置密码成功，显示登录 -->
    <div v-if="resetSuccess" style="text-align: center">
      <div class="login-form">
        <div class="successful">重置密码成功！</div>
      </div>
      <!-- 按钮 -->
      <div class="margin_a">
        <van-button style="width: 100%" type="info" @click="toLogin()"
          >返回登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "@/components/common/head.vue";
import api from "@/apis/api";
import tool from "@/common/tool";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: 'LoginForgotPassword',
  components: {
    headTop: headTop,
  },
  data() {
    return {
      resourceDomain: api.resourceDomain,
      token: "",
      registerAccount: "",
      code: "",
      setPassword: "",
      againPassword: "",

      resetSuccess: false,
      // 验证码相关
      show: true,
      count: "",
      timer: null,
    };
  },
  created() {
    this.token = this.getToken();
  },
  computed: {
    ...mapGetters("userModule", ["getToken"]),
  },
  methods: {
    ...mapMutations("userModule", ["SET_TOKEN", "SET_MOBILE"]),

    /**
     * 获取验证码
     */
    getCode() {
      if (!this.registerAccount.trim()) {
        this.$toast("请输入手机号码");
        return;
      }
      if (!tool.checkPhoneNumber(this.registerAccount)) {
        this.$toast("请输入正确的手机号");
        return;
      }

      console.log("获取验证码");
      api
        .get(`/p/user/getForgotPasswordCode/${this.registerAccount}`)
        .then((res) => {
          if (res.success) {
            const timeCount = 60;
            if (!this.timer) {
              let count = timeCount;
              let timer = this.timer;
              setTimeout(() => {
                this.count = count;
                this.show = false;
              }, 1000);
              timer = setInterval(() => {
                if (count > 0 && count <= timeCount) {
                  this.count = count--;
                } else {
                  clearInterval(timer);
                  this.timer = null;
                  this.show = true;
                }
              }, 1000);
            }
          } else {
            this.$toast(res.message);
          }
        });
	},
	/**
	 * 重置密码
	 */
	resetClick(){
      if (!tool.checkPhoneNumber(this.registerAccount)) {
        this.$toast("请输入正确的手机号");
        return;
	  }

	  if (!this.code.trim() || this.code.length != 4) {
        this.$toast("验证码输入错误");
        return;
      }

      if (!this.setPassword.trim()) {
        this.$toast("请输入密码");
        return;
	  }
	  
      if (this.setPassword.length < 6) {
        this.$toast("密码长度不足6位");
        return;
	  }

      if (this.setPassword != this.againPassword) {
        this.$toast("两次密码不一致");
        return;
      }
 
    // 请求重置密码
		this.$toast.loading({
			overlay: true,
			message: '重置密码中...',
			duration: 0
		})
      api.get("/p/user/updatePassword", {loginAccount: this.registerAccount,loginPassword: this.setPassword,code: this.code}).then(res=>{
        this.$toast.clear()
        console.log(res)
        if(res.success){
			this.resetSuccess = true
        }else{
			this.$toast(res.message)
        }
      })
	},

	/**
	 * 登录
	 */
	toLogin(){
		this.$router.go(-1);//返回上一层
	}

  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.padding_a{
		padding: 40px
	}
	.margin_a{
		margin: 40px
	}
.con {
  padding-top:48px;
	
}

button::after {
  border: 0 !important;
}

.to-register {
  font-size: 14px;
  color: #089ce7;
  text-align: right;
}
</style>
